import React, { useContext } from 'react';
import './Login.scss';
import { T } from '../../utils/I18n/I18n'

const Delete = () => {
  return (
    <div className="customer">
      <T id="login.delete" />
    </div>
  );
};

export default Delete;
